import type { TFunction } from "i18next";
import { z } from "zod";

/** Form schema of the edit drawer and page; the secrets stay empty unless they are changed. */
export const makeEditConnectionFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("edit.nameRequired")),
    baseUrl: z.string().min(1, t("edit.baseUrlRequired")),
    apiKey: z.string(),
    clientId: z.string(),
    clientSecret: z.string(),
  });

export type EditConnectionFormData = z.infer<ReturnType<typeof makeEditConnectionFormSchema>>;
